package com.anjuros.website.redesign.sections.contactforms

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdFaqBand
import com.anjuros.website.redesign.util.RdText

/** Contact form questions; also used for the FAQPage structured data. */
val ContactFormsFaqs = listOf(
    RdText.FORMS_FAQ1_Q to RdText.FORMS_FAQ1_A,
    RdText.FORMS_FAQ2_Q to RdText.FORMS_FAQ2_A,
    RdText.FORMS_FAQ3_Q to RdText.FORMS_FAQ3_A,
    RdText.FORMS_FAQ4_Q to RdText.FORMS_FAQ4_A,
)

@Composable
fun ContactFormsFaqSection() {
    RdFaqBand(RdText.FORMS_FAQ_TITLE, ContactFormsFaqs)
}
